export const APP_EVENT_NAMES = {
  NETWORK_ERROR: 'network-error-detected',
  NETWORK_SUCCESS: 'network-success-detected',
} as const;

export const NETWORK_ERROR_MESSAGE = 'Network Error';
